import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { providerPrefix } from 'configs/routePrefix';
import DealService from "services/Provider/DealService"
import ReceiptService from "services/Provider/ReceiptService"
import  StatusModal from "../StatusModal"
import  FeedbackModal from "../FeedbackModal"
import UploadReceiptModal from 'components/Website/Cards/UploadReceiptModal';
import MessageModal from '../MessageModal';

const CardItem = ({  history, item, setShouldGetData }) => {
    const dealService=new DealService()
    const receiptService = new ReceiptService()
    const [modalStatus, setModalStatus] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [sendMessage, setSendMessage] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const [deleteModal, setDeleteModal] = useState(false);
    const [formState, setFormState] = useState({media: item?.reciept})
    const [rModal, setRModal] =useState(false)
    const [status, setStatus] = useState(item?.status)

    const handleCloseModal = (action) => {
        setDeleteModal(false);
        if (action === "delete") { 
            setShouldGetData(true)
        }
    };

    return (
        <>
            <tr  >
                <th className="font-size-14">{item.id}</th>
                <th className="font-size-14">{item.client.user_name}</th>
                 <th className="font-size-14">{item.created_at}</th>
                <th className="font-size-14">{!!item?.unit?.unit_type?.name?.en ? item?.unit?.unit_type?.name?.en : item?.resale?.resale_type?.name?.en}</th>
                <th className="font-size-14">{!!item?.compound?.name?.en ? item?.compound?.name?.en : '-'}</th>
                <th className="font-size-14">{toCurrency(!!item?.price ? item?.price : item?.resale?.payment_plan?.total_price) }</th>
                <td className="font-size-14 text-left">
                    {!!item?.developer_status ? <Badge 
                        className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item?.developer_status[0]?.status) }}>
                            {item?.developer_status[0]?.status}
                    </Badge> : '-'}
                </td>
                 <th className="font-size-14 text-left">
                    <Badge className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(status) }}>{status}</Badge></th>                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() =>history.push(`${providerPrefix}/deals/view-deal/${item.id}`)}>View</DropdownItem>
                            <DropdownItem onClick={() =>history.push(`${providerPrefix}/deals/Edit-deal/${item.id}`)}>Edit</DropdownItem>
                            <DropdownItem onClick={() => setSendMessage(true)}>Send Message</DropdownItem>
                            <DropdownItem onClick={() =>history.push(`${providerPrefix}/deals/deal-activity/${item.id}/${item.lead_id}`) }>Add Activity</DropdownItem>
                            <DropdownItem onClick={()=>setFeedbackModal(true)}>Add Feedback</DropdownItem>
                            {!item?.reciept && status ==='Open' && <DropdownItem onClick={() => setRModal(true)}>Add Receipt for Client</DropdownItem>}
                            <DropdownItem onClick={() =>history.push(`${providerPrefix}/appoinments/book-appoinment/add/${item.lead_id}`) }>Book Appointment</DropdownItem>

                            <DropdownItem className="text-danger" onClick={() => { setDeleteModal(true) }}>Remove Deal</DropdownItem>
                            <hr className="m-0 p-0" />
                            <DropdownItem onClick={()=>setModalStatus(true)}  style={{color:"#212529"}} >Change Status</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            {rModal && 
                <UploadReceiptModal
                    rModal={rModal} 
                    setRModal={setRModal} 
                    form={formState.media} 
                    setStatus={setStatus}
                    dealId={item.id}
                    setShouldGetData={setShouldGetData}
                    Service={receiptService} 
                />}
            {deleteModal && 
                <DeleteModal
                    open={deleteModal}
                    titleMsg={"Appoinment"}
                    deletedItem={item}
                    modelService={dealService}
                    onCloseModal={(action) => handleCloseModal(action)}
                />}
            {modalStatus && 
                <StatusModal
                    modal={modalStatus}
                    toggle={() => setModalStatus(!modalStatus)}
                    status={item.status}
                    id={item.id}
                    setShouldGetData={setShouldGetData}
                />}
            {feedbackModal && 
                <FeedbackModal 
                    modal={feedbackModal}
                    id={item.id}
                    toggle={() => setFeedbackModal(!feedbackModal)}
                    type="list"
                    setShouldUpdateDate={() => { }}
                />}
                {sendMessage && <MessageModal 
                modal={sendMessage}
                id={item.id}
                setModal={setSendMessage}
                Service={dealService}
            />}
        </>

    );
}
const getBackGround = (status) => {
    return status === "Contacted" ? "#db1fdb"
        : status === "Uncontacted" ? "#74788d"
            : status === "Lost" ? "#bf060b"
                : status === "Won" ? "#34e38f"
                    : status === "Open" ? "#50a5f1" :
                    status === "Unreachable" ? "#556ee6" : "#f1874c"

}
const toCurrency = (number) => {
    const numberInt=parseInt(number)
    const formatter = new Intl.NumberFormat("en-US");
      return formatter.format(numberInt);
}

export default CardItem;